import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Follow_up_contoral extends Component {
    constructor() {
        super();
        this.state = {}
    }

    async componentDidMount() {
        let redirecttologin = myconfig.redirecttologin;
        let baseurl = myconfig.get_sid;
        let eid=null;
        await axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                eid=res.data.eid;
            }
        }).catch((e) => {
            console.log(e.message);
        });
        if(eid!=null){
            baseurl = myconfig.get_moving_vehicle;
            await axios.post(baseurl, {
                sid: window.localStorage.getItem("ntfms_sid"),
            }, {cancelToken: source.token}).then(res => {
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                   console.log(res.data);
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    btngetreport = (event) => {
        event.preventDefault();
        this.setState({
            allovehs: [],
            datas: [],
            txtfilter: '',
            allovehsl: false,
        })
        let redirecttologin = myconfig.redirecttologin;
        let baseurl = myconfig.get_follow_up;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            org: this.state.org,
            des: this.state.des,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'Success!',
                    text: res.data.msg,
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })

                this.setState({
                    allovehs: res.data,
                    datas: res.data.datas,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <Nav type="follow_up_contoral"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Movement Controller</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Follow-up</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                    </section>
                </div>
            </>
        )
    }
}
export default Follow_up_contoral;
